import { productCarouselConstants } from '../constants';

export function productCarousels(state = {}, action) {
  switch (action.type) {
    case productCarouselConstants.GETALL_REQUEST:
      return {
        state,
        loading: true,
      };
    case productCarouselConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false,
      };
    case productCarouselConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function AddProductCarousel(state = {}, action) {
  switch (action.type) {
    case productCarouselConstants.ADD_REQUEST:
      return {
        state,
        loading: true,
      };
    case productCarouselConstants.ADD_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false,
      };
    case productCarouselConstants.ADD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false,
      };
    default:
      return state;
  }
}

export function GetProductCarousel(state = {}, action) {
  switch (action.type) {
    case productCarouselConstants.GET_REQUEST:
      return {
        state,
        loading: true,
      };
    case productCarouselConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false,
      };
    case productCarouselConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function UpdateProductCarousel(state = {}, action) {
  switch (action.type) {
    case productCarouselConstants.UPDATE_REQUEST:
      return {
        state,
        loading: true,
      };
    case productCarouselConstants.UPDATE_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false,
      };
    case productCarouselConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false,
      };
    default:
      return state;
  }
}
